export default __webpack_public_path__ + "static/media/Bills.da9f3ee8.graphql";